import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTelegram } from "@fortawesome/free-brands-svg-icons";
import { useLocalization } from '../../utils/hooks/useLocalization'
import LanguageSelector from "../LanguageSelector/LanguageSelector"
import { ReactComponent as LogoTiny } from '../../assets/logo-tiny.svg';
import social from "../../data/social"
import styles from './Footer.module.css';

const Footer = () => {
  const { t } = useLocalization();
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.brand}>
            <div className={styles.brandName}>
              <LogoTiny />
            </div>
            <p className={styles.copyright}>©2026 <b>dtune</b>. {t("landing_copyright")}</p>
          </div>
          
          <div className={styles.socialLinks}>
            <a href={`https://www.instagram.com/${social.instagram}`} target='_blank' className={styles.socialLink}>
              <Instagram size={20} />
            </a>
            <a href={`https://www.facebook.com/${social.facebook}`} target='_blank' className={styles.socialLink}>
              <Facebook size={20} />
            </a>
            <a href={`https://t.me/${social.telegram}`} target='_blank' className={styles.socialLink}>
              <FontAwesomeIcon icon={faTelegram} style={{ fontSize: "20px" }} />
            </a>
          </div>
          <div>
            <LanguageSelector />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;